var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "school-info-container" },
    [
      _c(
        "el-form",
        {
          ref: "schoolData",
          staticClass: "modern-form",
          attrs: {
            model: _vm.schoolData,
            rules: _vm.rules,
            "label-position": "top",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 24 } },
            [
              _c("el-col", { attrs: { lg: 16, md: 24, sm: 24, xs: 24 } }, [
                _c("div", { staticClass: "modern-card" }, [
                  _c("div", { staticClass: "card-header" }, [
                    _c("i", { staticClass: "el-icon-school card-header-icon" }),
                    _c("span", { staticClass: "card-title" }, [
                      _vm._v("Thông tin chung"),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "card-body" },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Tên trường",
                                    prop: "schoolName",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "modern-input",
                                    attrs: { placeholder: "Nhập tên trường" },
                                    model: {
                                      value: _vm.schoolData.schoolName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.schoolData,
                                          "schoolName",
                                          $$v
                                        )
                                      },
                                      expression: "schoolData.schoolName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Mô tả",
                                    prop: "schoolDescription",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "modern-input",
                                    attrs: {
                                      type: "textarea",
                                      rows: 4,
                                      placeholder: "Nhập mô tả về trường",
                                    },
                                    model: {
                                      value: _vm.schoolData.schoolDescription,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.schoolData,
                                          "schoolDescription",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "schoolData.schoolDescription",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Địa chỉ",
                                    prop: "schoolAddress",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "modern-input",
                                    attrs: {
                                      placeholder: "Nhập địa chỉ trường",
                                    },
                                    model: {
                                      value: _vm.schoolData.schoolAddress,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.schoolData,
                                          "schoolAddress",
                                          $$v
                                        )
                                      },
                                      expression: "schoolData.schoolAddress",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 8, md: 8, sm: 24, xs: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Điện thoại",
                                    prop: "schoolPhone",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "modern-input",
                                    attrs: {
                                      placeholder: "Nhập số điện thoại",
                                    },
                                    model: {
                                      value: _vm.schoolData.schoolPhone,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.schoolData,
                                          "schoolPhone",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "schoolData.schoolPhone",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { lg: 8, md: 8, sm: 24, xs: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Email",
                                    prop: "schoolEmail",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "modern-input",
                                    attrs: {
                                      placeholder: "Nhập email liên hệ",
                                    },
                                    model: {
                                      value: _vm.schoolData.schoolEmail,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.schoolData,
                                          "schoolEmail",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "schoolData.schoolEmail",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { lg: 8, md: 8, sm: 24, xs: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Website",
                                    prop: "schoolWebsite",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "modern-input",
                                    attrs: {
                                      placeholder: "Nhập địa chỉ website",
                                    },
                                    model: {
                                      value: _vm.schoolData.schoolWebsite,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.schoolData,
                                          "schoolWebsite",
                                          $$v
                                        )
                                      },
                                      expression: "schoolData.schoolWebsite",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "modern-card system-stats-card" }, [
                  _c("div", { staticClass: "card-header" }, [
                    _c("i", {
                      staticClass: "el-icon-setting card-header-icon",
                    }),
                    _c("span", { staticClass: "card-title" }, [
                      _vm._v("Cấu hình & SMS"),
                    ]),
                  ]),
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "stats-grid" }, [
                      _c("div", { staticClass: "stat-box" }, [
                        _c("div", { staticClass: "stat-icon-wrapper purple" }, [
                          _c("i", { staticClass: "el-icon-key" }),
                        ]),
                        _c("div", { staticClass: "stat-content" }, [
                          _c("div", { staticClass: "stat-label" }, [
                            _vm._v("Mã xử lý"),
                          ]),
                          _c("div", { staticClass: "stat-value" }, [
                            _vm._v(_vm._s(_vm.schoolData.verifyCode)),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "stat-box" }, [
                        _c("div", { staticClass: "stat-icon-wrapper orange" }, [
                          _c("i", { staticClass: "el-icon-message" }),
                        ]),
                        _c("div", { staticClass: "stat-content" }, [
                          _c("div", { staticClass: "stat-label" }, [
                            _vm._v("SMS đã dùng"),
                          ]),
                          _c("div", { staticClass: "stat-value" }, [
                            _vm._v(_vm._s(_vm.schoolData.smsUsed)),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "stat-box" }, [
                        _c("div", { staticClass: "stat-icon-wrapper green" }, [
                          _c("i", { staticClass: "el-icon-pie-chart" }),
                        ]),
                        _c("div", { staticClass: "stat-content" }, [
                          _c("div", { staticClass: "stat-label" }, [
                            _vm._v("SMS còn lại"),
                          ]),
                          _c("div", { staticClass: "stat-value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.schoolData.smsTotal - _vm.schoolData.smsUsed
                              )
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
              _c("el-col", { attrs: { lg: 8, md: 24, sm: 24, xs: 24 } }, [
                _c("div", { staticClass: "modern-card avatar-card" }, [
                  _c("div", { staticClass: "card-header" }, [
                    _c("i", {
                      staticClass: "el-icon-picture card-header-icon",
                    }),
                    _c("span", { staticClass: "card-title" }, [
                      _vm._v("Ảnh đại diện trường"),
                    ]),
                  ]),
                  _c("div", { staticClass: "card-body avatar-body" }, [
                    _c("div", { staticClass: "school-avatar-container" }, [
                      _c(
                        "div",
                        { staticClass: "avatar-preview-box" },
                        [
                          _vm.schoolData.schoolAvatar != null &&
                          _vm.showPicutreInitial
                            ? _c("el-image", {
                                staticClass: "school-avatar-preview",
                                attrs: {
                                  src: _vm.schoolData.schoolAvatar,
                                  fit: "cover",
                                },
                              })
                            : _vm._e(),
                          _c(
                            "el-upload",
                            {
                              ref: "upload",
                              staticClass: "school-avatar-uploader",
                              class: {
                                hideUpload: !_vm.showUpload,
                                "has-avatar": _vm.schoolData.schoolAvatar,
                              },
                              attrs: {
                                "show-file-list": true,
                                "list-type": "picture-card",
                                "on-change": _vm.handleChangeUpload,
                                "on-remove": _vm.handleRemove,
                                "auto-upload": false,
                                limit: "1",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "upload-trigger-content" },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-camera upload-camera-icon",
                                  }),
                                  _c("span", { staticClass: "upload-text" }, [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.schoolData.schoolAvatar != null
                                            ? "Thay đổi ảnh"
                                            : "Tải ảnh lên"
                                        ) +
                                        "\n                    "
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "avatar-note" }, [
                      _c("i", { staticClass: "el-icon-info" }),
                      _c("span", [
                        _vm._v("Ảnh định dạng JPG/PNG. Dung lượng tối đa 5MB."),
                      ]),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "modern-card contacts-card" }, [
                  _c("div", { staticClass: "card-header" }, [
                    _c("i", { staticClass: "el-icon-phone card-header-icon" }),
                    _c("span", { staticClass: "card-title" }, [
                      _vm._v("Thông tin liên hệ"),
                    ]),
                  ]),
                  _c("div", { staticClass: "card-body" }, [
                    _c(
                      "div",
                      { staticClass: "contact-section" },
                      [
                        _c("div", { staticClass: "contact-section-title" }, [
                          _vm._v("Liên hệ chính (1)"),
                        ]),
                        _c(
                          "el-row",
                          { attrs: { gutter: 10 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Số điện thoại",
                                      prop: "contactPhone1",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "modern-input",
                                      attrs: { placeholder: "Số điện thoại 1" },
                                      model: {
                                        value: _vm.schoolData.contactPhone1,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.schoolData,
                                            "contactPhone1",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "schoolData.contactPhone1",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Họ tên",
                                      prop: "contactName1",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "modern-input",
                                      attrs: { placeholder: "Nhập tên" },
                                      model: {
                                        value: _vm.schoolData.contactName1,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.schoolData,
                                            "contactName1",
                                            $$v
                                          )
                                        },
                                        expression: "schoolData.contactName1",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "contact-section" },
                      [
                        _c("div", { staticClass: "contact-section-title" }, [
                          _vm._v("Liên hệ phụ (2)"),
                        ]),
                        _c(
                          "el-row",
                          { attrs: { gutter: 10 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Số điện thoại",
                                      prop: "contactPhone2",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "modern-input",
                                      attrs: { placeholder: "Số điện thoại 2" },
                                      model: {
                                        value: _vm.schoolData.contactPhone2,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.schoolData,
                                            "contactPhone2",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "schoolData.contactPhone2",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Họ tên",
                                      prop: "contactName2",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "modern-input",
                                      attrs: { placeholder: "Nhập tên" },
                                      model: {
                                        value: _vm.schoolData.contactName2,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.schoolData,
                                            "contactName2",
                                            $$v
                                          )
                                        },
                                        expression: "schoolData.contactName2",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "contact-section" },
                      [
                        _c("div", { staticClass: "contact-section-title" }, [
                          _vm._v("Liên hệ khác (3)"),
                        ]),
                        _c(
                          "el-row",
                          { attrs: { gutter: 10 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Số điện thoại",
                                      prop: "contactPhone3",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "modern-input",
                                      attrs: { placeholder: "Số điện thoại 3" },
                                      model: {
                                        value: _vm.schoolData.contactPhone3,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.schoolData,
                                            "contactPhone3",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "schoolData.contactPhone3",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Họ tên",
                                      prop: "contactName3",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "modern-input",
                                      attrs: { placeholder: "Nhập tên" },
                                      model: {
                                        value: _vm.schoolData.contactName3,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.schoolData,
                                            "contactName3",
                                            $$v
                                          )
                                        },
                                        expression: "schoolData.contactName3",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form-actions-bar" },
            [
              _vm.checkPermission(["schoolConfig_school_update"])
                ? _c(
                    "el-button",
                    {
                      staticClass: "modern-btn-submit",
                      attrs: {
                        type: "success",
                        size: "medium",
                        loading: _vm.loadingButton,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("schoolData")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-check" }),
                      _c("span", [_vm._v("Lưu thông tin")]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }